// Français pour l'échelle des obligations — les titres de barreaux, les phrases de repli, les
// libellés de route et primaires, et RUNG_NOUN. Les phrases de blocage propres au serveur sont
// citées sans retouche (B7) et ne figurent pas dans ce catalogue.
import { registerFr } from '../../i18n/index.js';

registerFr({
  // RUNG_NOUN
  'held': 'retenu',
  'the review queue': 'la file d’attente',
  'funded': 'financé',
  'justified': 'justifié',
  'proven': 'prouvé',

  // 1 · held
  'Every requirement held': 'Toutes les exigences retenues',
  'The register is empty — nothing is on record to confirm.': 'Le registre est vide — il n’y a rien à confirmer.',
  '{held} of {total} requirements held': '{held} exigences retenues sur {total}',
  'the {n} row still proposed': 'la {n} ligne encore proposée',
  'the {n} rows still proposed': 'les {n} lignes encore proposées',
  'All rows': 'Toutes les lignes',
  'Confirm {n} proposed': 'Confirmer {n} proposée(s)',

  // 2 · queue
  'Zero pending proposals': 'Aucune proposition en attente',
  'The review queue is clear.': 'La file d’attente est vide.',
  '{n} proposal awaiting review': '{n} proposition en attente de vérification',
  '{n} proposals awaiting review': '{n} propositions en attente de vérification',
  'Proposals': 'Propositions',
  'Review {n} proposal': 'Vérifier {n} proposition',
  'Review {n} proposals': 'Vérifier {n} propositions',

  // 3 · funded
  'Every MUST requirement maps to a deliverable': 'Chaque exigence Doit est associée à un livrable',
  'No MUST requirement is on the register — the gate wants at least one.': 'Aucune exigence Doit dans le registre — le gate en exige au moins une.',
  '{mapped} of {total} MUST requirements mapped': '{mapped} exigences Doit associées sur {total}',
  'the unfunded musts': 'les exigences Doit non financées',
  'Map the unfunded musts': 'Associer les exigences Doit non financées',

  // 4 · justified
  'No deliverable without a requirement': 'Aucun livrable sans exigence',
  'No deliverable is defined — there is nothing for a requirement to map to.': 'Aucun livrable défini — il n’y a rien auquel une exigence puisse être associée.',
  '{n} of {total} deliverables carry at least one requirement': '{n} livrables sur {total} portent au moins une exigence',
  'Deliverables': 'Livrables',
  'Open the deliverables': 'Ouvrir les livrables',

  // 5 · proven
  'Every acceptance criterion has a test case': 'Chaque critère d’acceptation a un cas de test',
  'No acceptance criterion is on record yet — nothing here is testable.': 'Aucun critère d’acceptation n’est encore enregistré — rien n’est testable ici.',
  '{n} of {total} criteria have a test case': '{n} critères sur {total} ont un cas de test',
  'Test cases': 'Cas de test',
  'Propose test cases for {n} criterion': 'Proposer des cas de test pour {n} critère',
  'Propose test cases for {n} criteria': 'Proposer des cas de test pour {n} critères',
}, 'ladder');
